import api from "../../client";
import { UpdateLinkPayload, UpdateLinkResponseData } from "../../types/link";

export const updateLinkRequest = async (
  id: string,
  payload: UpdateLinkPayload,
): Promise<UpdateLinkResponseData> => {
  const { data } = await api.put<UpdateLinkResponseData>(
    `/link/${id}`,
    payload,
  );

  return data;
};
